import { makeStyles } from '@material-ui/core/styles'
const StylesWithMaterialUi = makeStyles(() => ({
  btn: {
    fontSize: '12px',
    fontWeight: 'Bold',
    fontFamily: 'Comfortaa',
    textTransform: 'none',
    maxHeight: '110px',
  },
}))
export default StylesWithMaterialUi
